export default {
      id: "aure-open-compartment-usage",
      viewBox: "0 0 1191 842",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#aure-open-compartment",
      toString: function () {
        return this.url;
      }
    }